<div class="building-efficiency-details">
  <table aria-describedby="building-efficiency-details">
    <th scope="sonarqubefix" class="sonarqubefix"></th>
    <tr class="table-row">
      <td class="table-cell -header name">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.nameHeaderText' | translate }}</td>
      <td class="table-cell -header address">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.addressHeaderText' | translate }}</td>
      <td class="table-cell -header date">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.dateHeaderText' | translate }}</td>
      <td class="table-cell -header note">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.noticeHeaderText' | translate }}</td>
      <td class="table-cell -header electricity-efficiency">
        <div class="title">
          <div>{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.energyEfficiencyHeaderText' | translate }}</div>
          <div class="electricity">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.electricityHeaderText' | translate }}</div>
        </div>
      </td>
      <td class="table-cell -header heat-efficiency">
        <div class="title">
          <div>{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.energyEfficiencyHeaderText' | translate }}</div>
          <div class="heat">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.heatHeaderText' | translate }}</div>
          <div class="heat">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.weatherAdjustment' | translate }}</div>
        </div>
      </td>
      <td class="table-cell -header update">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.updateHeaderText' | translate }}</td>
      <td class="table-cell -header delete">{{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.deleteHeaderText' | translate }}</td>
      <td class="table-cell -header details"></td>
    </tr>
    <tr class="details" *ngFor="let building of buildings">
      <td colspan="7">
        <tr class="table-row">
          <td class="table-cell name">{{ building.buildingName }}</td>
          <td class="table-cell address">{{ building | getAddress }}</td>
          <td class="table-cell date">{{ getDate(building.efficiencyAnalysisDate) }}</td>
          <td class="table-cell note">
            <app-note-pop-up
              [value]="building.notes"
              class="note-pop-up-component"
              [(updateSuccess)]="building.isNoteUpdateSuccess"
              [placeholder]="'Notiz einfügen'"
              [canEdit]="authService.isAdminAreaAndMunicipalityWorker"
              (saveEvent)="onUpdateNote(building, $event)"
            ></app-note-pop-up>
          </td>
          <td class="table-cell electricity-efficiency">
            <div class="cell-details">
              <div class="col1">{{ getLocalNumber(building.electricityComputedValue) }} kWh/(m²a)</div>
              <div class="col2" [ngStyle]="{ 'background-color': building.electricityColorStatus }"></div>
            </div>
          </td>
          <td class="table-cell heat-efficiency">
            <div class="cell-details">
              <div class="col1">{{ getLocalNumber(building.heatComputedValue) }} kWh/(m²a)</div>
              <div class="col2" [ngStyle]="{ 'background-color': building.heatColorStatus }"></div>
            </div>
          </td>
          <td class="table-cell update">
            <a (click)="openQuestionnaire(building.guid)">
              <span class="fa fa-pencil" aria-hidden="true"></span>
            </a>
          </td>
          <td class="table-cell delete">
            <a (click)="delete(building.guid)">
              <span class="fa fa-trash" aria-hidden="true"></span>
            </a>
          </td>
          <td class="table-cell details">
            <a (click)="openChart(building.guid)">
              <span class="fa fa-bar-chart" aria-hidden="true"></span> {{ 'module.efficiencyAnalysis.buildingEfficiencyDetails.detailsLinkText' | translate }}
            </a>
          </td>
        </tr>
      </td>
    </tr>
  </table>

  <div *ngIf="showQuestionnaire" class="overlay">
    <app-building-efficiency-wizard
      class="building-efficiency-wizard"
      [buildingZipcode]="selectedBuilding.zipCode"
      [buildingGuid]="selectedBuilding.guid"
      [visibility]="showQuestionnaire"
      (closeEvent)="closeQuestionnaire($event)"
      (saveEmitter)="saveEfficiencyAnalysis($event)"
    >
    </app-building-efficiency-wizard>
  </div>

  <div *ngIf="showChart" class="overlay">
    <app-building-efficiency-wizard
      class="building-efficiency-wizard"
      *ngIf="showChart"
      [buildingZipcode]="selectedBuilding.zipCode"
      [buildingGuid]="selectedBuilding.guid"
      [visibility]="showChart"
      (closeEvent)="closeQuestionnaire($event)"
      (saveEmitter)="saveEfficiencyAnalysis($event)"
      [currentStep]="numberOfSteps"
      [isDisabled]="false"
      [viewResults]="true"
    >
    </app-building-efficiency-wizard>
  </div>
</div>
